import React, { useEffect, useState } from 'react'
import styles from './style.module.scss'
import init from './webgl'

const LogoLoader = ({ width = 500, height = 500, text, className }) => {
  const [initialized, setInitialized] = useState(false)
  const canvas = React.createRef()
  const image = React.createRef()

  useEffect(() => {
    if (image.current && canvas.current && !initialized) {
      init(image.current, canvas.current)
      setInitialized(true)
      // setInterval(randomizePixels, 5000)
    }
  }, [image, canvas, initialized])

  return (
    <div className={className}>
      <canvas ref={image} className="d-none" />
      <canvas ref={canvas} id="c" className={styles.animatedLogo} width={width} height={height} />
      <div className={styles.text}>{text}</div>
    </div>
  )
}

export default LogoLoader
